import React from "react";
import { ResponsiveContainer, ComposedChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Area, Bar, Line } from "recharts";
import { mapAnaliseComposta } from "../utils/chartTransforms";

const AnaliseCompostaComposed = ({ data = [], height = 400 }) => {
  const series = mapAnaliseComposta(data);
  return (
    <ResponsiveContainer width="100%" height={height}>
      <ComposedChart data={series} margin={{ top: 30, right: 40, bottom: 50, left: 30 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" tick={{ fontSize: 12 }} interval={0} />
        <YAxis />
        <Tooltip
          formatter={(value, name, obj) => {
            if (name === "totalNCEs") return [`${value} NCEs`, "Total"];
            if (name === "qtdDefeitos") return [`${value} tipos`, "Defeitos"];
            if (name === "qtdUnidades") return [`${value} unidades`, "Unidades"];
            return value;
          }}
          contentStyle={{ fontSize: 12 }}
          labelFormatter={(label, payload) => {
            const d = payload?.[0]?.payload;
            return (
              <>
                <div style={{ fontWeight: "bold", marginBottom: 4 }}>Fornecedor: {label}</div>
                <div><strong>Defeitos:</strong> {d?.defeitos}</div>
                <div><strong>Unidades:</strong> {d?.unidades}</div>
              </>
            );
          }}
        />
        <Legend />
        <Area type="monotone" dataKey="qtdDefeitos" fill="#82ca9d" stroke="#82ca9d" fillOpacity={0.2} />
        <Bar dataKey="totalNCEs" barSize={40} fill="#8884d8" name="Total de NCEs" />
        <Line type="monotone" dataKey="qtdUnidades" stroke="#ff7300" strokeWidth={2} dot={{ r: 3 }} name="Qtd. Unidades" />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default AnaliseCompostaComposed;
